<template>
    <b-card no-body>
        <b-card-header class="border-0 job-group-table-headers">
            <base-input label="Name" placeholder="Name" v-model="filters.name__icontains" />
            <router-link :to="'/job_group/new'" class="d-flex align-items-center">
                <base-button icon type="info" class="btn btn-info">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-add"/>
                    </span>
                </base-button>
            </router-link>
        </b-card-header>
        <div v-if="isLoading">
            <card>Loading...</card>
        </div>
        <template v-else>
            <el-table class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="jobGroups">
                <el-table-column label="Name" prop="name" />
                <el-table-column label="Actions" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center justify-content-end">
                            <router-link v-bind:key="row.id" :to="'/job_group/'+row.id">
                                <base-button icon type="info">
                                    <span class="btn-inner--icon">
                                        <i class="ni ni-align-center"/>
                                    </span>
                                </base-button>
                            </router-link>
                            <base-button icon type="info" @click="runJobGroup(row.id)">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-button-play"/>
                                </span>
                            </base-button>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="10" :total="total" @change="pageChanged">
                    <template v-slot:prev-text>
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                        </a>
                    </template>
                </base-pagination>
            </b-card-footer>
        </template>
        
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const JobGroupRepository = RepositoryFactory.get('job_group')

export default {
    name:'job-group-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    created(){
        this.getPage(this.currentPage)
    },
    data(){
        return {
            currentPage: 1,
            total:0,
            jobGroups:null,
            lastRequestTimestamp:0,

            filters:{},
            filterTimer:undefined, // Filtre her inputta değil kullanıcı yazmayı bıraktığında çalışsın diye

            isLoading:true,
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.currentPage=pageNumber;
            
            JobGroupRepository.getTable(pageNumber,this.filters).then((response) => {
                if(this.lastRequestTimestamp!==timestamp) return;

                var r = response.data;
                
                this.total=r.count;
                this.jobGroups=r.results;
                this.currentPage=pageNumber;

                this.isLoading=false
            })
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        },
        runJobGroup(id){
            JobGroupRepository.runJobGroup(id).then((response) => {
                this.$notify({
                message: 'Job group started successfully',
                type: 'success', // success, warning, error
                size: 'lg', // or 'sm'
                timeout: 5000,
                showClose: true
                })
                // alert('Job started successfully')
            })
        }   
    }

}
</script>

<style>

.job-group-table-headers {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

</style>